/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Override uppercase on SKU block to allow mixed case (e.g. lowercase barcode label)
  var style = document.createElement('style');
  style.textContent = '.product__sku { text-transform: none; }';
  document.head.appendChild(style);

  // Append barcode to SKU block — on load and on variant change
  function getProductData() {
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return null;
    try { return JSON.parse(jsonEl.innerHTML); } catch(e) { return null; }
  }

  function getSelectedVariantId() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('variant')) return params.get('variant');
    var checked = document.querySelector('[data-single-option-selector]');
    return checked ? null : null;
  }

  function updateSkuBarcode(variantId) {
    var skuWrapper = document.querySelector('[data-variant-sku]');
    if (!skuWrapper) return;
    var product = getProductData();
    if (!product) return;
    var variant = product.variants.find(function(v) { return String(v.id) === String(variantId); });
    if (!variant) return;
    skuWrapper.innerHTML = variant.barcode ? 'Barcode: ' + variant.barcode : '';
  }

  // On variant change
  document.addEventListener('theme:variant:change', function(e) {
    var variant = e.detail && e.detail.variant;
    if (variant) setTimeout(function() { updateSkuBarcode(String(variant.id)); }, 0);
  });

  // On page load
  document.addEventListener('DOMContentLoaded', function() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) {
      var product = getProductData();
      if (product && product.variants && product.variants.length) {
        variantId = String(product.variants[0].id);
      }
    }
    if (variantId) updateSkuBarcode(variantId);
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
